import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e951df66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "text item" }
const _hoisted_3 = { class: "data-card" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "magnitude" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "data-card" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "magnitude" }
const _hoisted_10 = { class: "filter-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "box-card" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("label.dataOperational")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_card, { shadow: "never" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("label.identifying")) + ":", 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.station), 1)
            ])
          ]),
          _: 1
        })
      ]),
      (_ctx.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (o) => {
              return (_openBlock(), _createElementBlock("div", {
                key: o.id,
                class: "text item"
              }, [
                _createVNode(_component_el_card, {
                  class: _normalizeClass(_ctx.classDataCard(o)),
                  onClick: ($event: any) => (_ctx.handleParameterClick(o)),
                  shadow: "never"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("magnitude." + o.magnitude).includes("magnitude")
                  ? o.magnitude
                  : _ctx.$t("magnitude." + o.magnitude)) + ": ", 1),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(o.measurement) + " " + _toDisplayString(o.unit), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"])
              ]))
            }), 128)),
            _createVNode(_component_el_dialog, {
              title: 
          'Historial de ' +
          (_ctx.$t('magnitude.' + this.magnitude) !== 'magnitude.' + this.magnitude
            ? _ctx.$t('magnitude.' + this.magnitude)
            : this.magnitude)
        ,
              modelValue: _ctx.isPopupVisible,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isPopupVisible) = $event)),
              width: "50%",
              onClose: _ctx.resetFilters
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("label.filterBar")), 1),
                _createVNode(_component_el_row, {
                  gutter: 10,
                  class: "filter-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.startDate,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                          type: "date",
                          placeholder: _ctx.$t('label.fromDate'),
                          format: _ctx.$t('format.dateTime'),
                          class: "date-picker",
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder", "format"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.endDate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event)),
                          type: "date",
                          placeholder: _ctx.$t('label.endDate'),
                          format: _ctx.$t('format.dateTime'),
                          class: "date-picker",
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder", "format"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 10 }, {
                      default: _withCtx(() => [
                        (_ctx.parametersSelect.includes(this.magnitude))
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 0,
                              modelValue: _ctx.selectedValue,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedValue) = $event)),
                              placeholder: _ctx.$t('label.searchValue'),
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (option) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: option.value,
                                    label: option.label,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"]))
                          : (_openBlock(), _createBlock(_component_el_input, {
                              key: 1,
                              modelValue: _ctx.searchQuery,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery) = $event)),
                              placeholder: _ctx.$t('label.searchValue'),
                              class: "text-input",
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  gutter: 10,
                  class: "filter-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 12,
                      style: {"text-align":"left"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "default",
                          onClick: _ctx.resetFilters,
                          class: "apply-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("tooltip.refresh")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 12,
                      style: {"text-align":"right"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.applyFilters,
                          class: "apply-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("btn.search")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table, { data: _ctx.historyData }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "date",
                      label: _ctx.$t('label.date'),
                      width: "180"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      prop: "value",
                      label: _ctx.$t('label.value')
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(_component_el_pagination, {
                  class: "app-table",
                  layout: "total, sizes, prev, pager, next, jumper",
                  currentPage: _ctx.currentPage,
                  "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event)),
                  "page-sizes": [10, 20, 50],
                  "page-size": _ctx.rowPerPage,
                  total: _ctx.totalRows,
                  onSizeChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePaginationSize($event))),
                  onCurrentChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePaginationPage($event)))
                }, null, 8, ["currentPage", "page-size", "total"])
              ]),
              _: 1
            }, 8, ["title", "modelValue", "onClose"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}